if (!window.customElements.get('floating-collection-buttons')) {
  class FloatingCollectionButtons extends HTMLElement {
    constructor() {
      super();
      this.motion = null;
      this.scrollObserver = null;
      this.isVisible = false;
      this.firstSection = null;
      this.startHeight = 0;
    }

    getStartHeight() {
      const collectionHeader = document.querySelector('.collection-header');
      const headerNav = document.querySelector('header-component nav') || document.querySelector('header-v2 nav');
      const h1 = (collectionHeader && collectionHeader.offsetHeight) || 0;
      const h2 = (headerNav && headerNav.offsetHeight) || 0;
      return h1 + h2 + 20;
    }

    connectedCallback() {
      whenReady('motion', (motion) => {
        this.motion = motion;
        setTimeout(() => {
          this.init();
        }, 100);
      });
    }

    init() {
      this.firstSection = document.querySelector('#MainContent .shopify-section');
      if (!this.firstSection) {
        console.warn('FloatingCollectionButtons: No .shopify-section found');
        return;
      }
      this.startHeight = this.getStartHeight();

      this.motion.animate(this, { 
        opacity: 0,
        visibility: 'hidden'
      }, { duration: 0 });
      this.isVisible = false;

      this.scrollObserver = this.motion.scroll(
        this.motion.animate(this, {
          opacity: [1, 0, 0, 1]
        }),
        {
          target: this.firstSection,
          offset: [`${this.startHeight}px start`, `${this.startHeight + 200}px start`, `${this.startHeight + 200}px start`, `${this.startHeight}px start`]
        }
      );

      // Set initial state based on current scroll position
      this.updateVisibility();
      
      const backToTopButton = this.querySelector('#back-to-top');
      if (backToTopButton) {
        backToTopButton.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }

      // Add close button functionality
      const closeButton = this.querySelector('.floating-collection-buttons__trigger-close');
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.fadeOutAndRemove();
        });
      }
    }

    fadeIn() {
      if (!this.isVisible) {
        this.isVisible = true;
        this.motion.animate(this, {
          opacity: 1,
          visibility: 'visible'
        }, {
          duration: 0.3,
          ease: 'easeOut',
          onComplete: () => {
            if(this.querySelector('.floating-collection-buttons__content') !== null) {
              this.querySelector('.floating-collection-buttons__content').style.pointerEvents = 'auto';
            }
          }
        });
      }
    }

    fadeOut() {
      if (this.isVisible) {
        this.isVisible = false;
        this.motion.animate(this, {
          opacity: 0,
          visibility: 'hidden'
        }, {
          duration: 0.3,
          ease: 'easeIn',
          onComplete: () => {
            if(this.querySelector('.floating-collection-buttons__content') !== null) {
              this.querySelector('.floating-collection-buttons__content').style.pointerEvents = 'none';
            }
          }
        });
      }
    }

    fadeOutAndRemove() {
      this.motion.animate(this, {
        opacity: 0,
        visibility: 'hidden'
      }, {
        duration: 0.3,
        ease: 'easeIn',
        onComplete: () => {
          // Remove the component from the DOM
          this.remove();
        }
      });
    }

    updateVisibility() {
      // Match ScrollTrigger's start: 400, end: 500
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY >= 500 && !this.isVisible) {
        this.fadeIn();
      } else if (scrollY < 400 && this.isVisible) {
        this.fadeOut();
      }
      // Between 400 and 500, do not force a state change (let ScrollTrigger handle it)
    }

    disconnectedCallback() {
      if (this.scrollObserver) {
        this.scrollObserver.stop();
        this.scrollObserver = null;
      }
    }
  }

  window.customElements.define('floating-collection-buttons', FloatingCollectionButtons);
}
